import script from "./ClinicalCardHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ClinicalCardHeader.vue?vue&type=script&setup=true&lang=js"

import "./ClinicalCardHeader.vue?vue&type=style&index=0&id=1d38506a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d38506a"]])

export default __exports__